import classNames from 'classnames/bind';
import { Heading1 } from '@entur/typography';
import NextAndBackButtons from 'components/NextBackButtons/NextAndBackButtons';
import React from 'react';
import LeftGroup from './LeftGroup';
import RightGroup from './RightGroup';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

interface PageHeaderProps {
  rightGroup?: React.ReactNode;
  children?: React.ReactNode;
  heading: string;
  nextButton?: boolean;
  renderCustom?: () => React.ReactNode;
  element?: string | number;
  notId?: boolean;
}

const PageHeader = ({
  children,
  heading,
  element,
  rightGroup,
  nextButton = false,
  renderCustom,
  notId = false,
}: PageHeaderProps) => {
  const hasGroupedChildren = () => {
    let isGroup = false;
    React.Children.forEach(children, (child) => {
      if (React.isValidElement(child) && (child.type === LeftGroup || child.type === RightGroup)) {
        isGroup = true;
      }
    });
    return isGroup;
  };
  const detailsClasses = cx({
    details: true,
    flex: hasGroupedChildren(),
  });

  return (
    <section>
      <div className={styles.headingLine}>
        <Heading1>{heading}</Heading1>
        <div className={styles.items}>
          {(element || element === 0) && !notId && <Heading1>#{element}</Heading1>}
          {(element || element === 0) && notId && <Heading1>{element}</Heading1>}
          {nextButton && <NextAndBackButtons id={element === undefined ? undefined : String(element)} />}
          {renderCustom && renderCustom()}
        </div>
        {rightGroup && rightGroup}
      </div>
      {children && <div className={detailsClasses}>{children}</div>}
    </section>
  );
};

PageHeader.LeftGroup = LeftGroup;
PageHeader.RightGroup = RightGroup;

export default PageHeader;
